import React, { useEffect, useState } from "react";
import FailedModal from "../../../../CustomModal/Failed";
import Loader from "../../../../../Loader/Loader";
import DashboardMenu from "../../../../layout/dashboardMenu";
import Header from "../../../../layout/header";
import useLatLng from "../../../../../hooks/uselatlng/uselatlng";
import { toast } from "react-toastify";
import DistanceCalculator from "../../../../DistanceCalculator/Calculator";
import SuccessModal from "../../../../CustomModal/Success";

const CompleteUCDActivity = ({
  documentUploadUrlPublic,
  documentUrlDataPublic,
  history,
  match,
  markAttendances,
  markAttendanceDetails = [],
  saveActivity,
  NewActivityDetails = [],
  getActivityDetails = [],
  isCheckoutDetails = [],
  getJourney,
  getUserJourney = [],
  isCheckout,
  accountDetailsById,
  accountDetails = [],
  viewActivity,
  activityByIdDetails=[]
}) => {
  var now = new Date();
  now.setMinutes(now.getMinutes() - now.getTimezoneOffset());
  const islatlng = useLatLng();
  const [isLoading, setIsLoading] = useState(false);
  const [isFailedModalOpen, setIsFailedModalOpen] = useState(false);
  const [countToOpenModal, setCountToOpenModal] = useState(0);
  const [mapLocation, setMapLocation] = useState({
    address: "Delhi",
    lat: 0,
    lng: 0,
  });
  const [isAllow, setIsAllow] = useState(false);
  const [inputList, setInputList] = useState([
    {
      meta_data: {},
      lat: "",
      long: "",
      checked: "",
      attendance_id: "",
      module_type: "",
      next_activity_date: "",
      next_activity_type_id: "",
    },
  ]);
  const [openCheckIn, setOpenCheckIn] = useState(false);
  const [isActivityCreated, setIsActivityCreated] = useState(false);
  // const [purposeOfVisit, setPurposeOfVisit] = useState([{visit_purpose: ''}])
  const [checkInText, setCheckInText] = useState("");
  const [accountId, setAccountId] = useState("");
  const [isEdit, setIsEdit] = useState(false);
  const [isSuccessModalOpen, setIsSuccessModalOpen] = useState(false);
  const [message, setMessage] = useState("");
  const [showSelfie, setShowSelfie] = useState(true);
  const [hideCheckIn, setHideCheckIn] = useState(false);

  useEffect(() => {
    (async () => {
      setIsLoading(true);
      await viewActivity(match?.params?.id);
      await isCheckout("UCD", match?.params?.account_id);
      await accountDetailsById(match?.params?.account_id);
      await getJourney("UCD");
      setIsLoading(false);
    })();
  }, []);


    useEffect(() => {
        // after check in hide popup
        if (markAttendanceDetails?.data && markAttendanceDetails?.status === 200) {
            toast.success("Attendance is marked successfully")
            setOpenCheckIn(false);
            window.location.href = `ucd-activity-list/${match?.params?.account_id}`
        }else if(markAttendanceDetails?.data !== undefined && markAttendanceDetails?.status !== 200){
            toast.warning(markAttendanceDetails?.message);
            setTimeout(() => {
              // window.location.href = `ucd-activity-list/${match?.params?.account_id}`
            }, 1000)
        }
    }, [markAttendanceDetails])

  useEffect(() => {
    console.log(activityByIdDetails)
    //  if activity is completed then check is either check out or not, if not then open check out popup
    if (
      isCheckoutDetails?.data  &&
      activityByIdDetails?.data
    ) {
      if (activityByIdDetails?.data?.activity_type_id) {
        let list = [...inputList];
        list[0]["activity_type_id"] = activityByIdDetails?.data?.activity_type_id;
        list[0]["activity_date"] = activityByIdDetails?.data?.activity_date;
        list[0]["id"] = activityByIdDetails?.data?.id;
        setAccountId(getActivityDetails?.data?.account_id);
        setInputList(list);
      }

      if (
        isCheckoutDetails?.data?.check_out_lat === null &&
        Object.keys(activityByIdDetails?.data).length === 0
      ) {
        setOpenCheckIn(true);
      }

      if (Object.keys(activityByIdDetails?.data).length > 0) {
        setIsActivityCreated(true);
      }

      if (
        !isCheckoutDetails?.data?.activity_id &&
        Object.keys(activityByIdDetails?.data).length > 0
      ) {
        setOpenCheckIn(true);
        setCheckInText("Check In");
      }
    } else {
      // window.location.href = ""
    }
  }, [isCheckoutDetails, activityByIdDetails]);


  const handleSubmit = async (e) => {
    e.preventDefault();
    let list = inputList[0];
    if (list["activity_type_id"] === "") {
      toast.error("Please choose activity type");
      return false;
    }

        list['module_type'] = 'UCD'
        list['dealer_type'] = 'UCD'
        list['lat'] = islatlng?.lat
        list['long'] = islatlng?.lng
    if (list["long"] == null || list["lat"] == null) {
      toast.error("Please enable your location");
      return false;
    }

    if (!isActivityCreated && list["activity_type_id"] !== "") {
      toast.error("No pending activity! Create new one.");
      return false;
    }

    if (list?.meta_data?.MOM !== undefined && list?.meta_data?.MOM.length < 70) {
      toast.warning("MOM must be minimum 70 characters");
      return false;
    }
    list["account_id"] = accountId;
   
    // console.log("listlistlistlist " + JSON.stringify(list))
    // return false
    setIsLoading(true);
    await saveActivity(list);
    setIsLoading(false);
  };

  const handleInput = (key, val, metaKey, e, i = 0) => {
    let list = [...inputList];
    if (key === "meta_data") {
      if (e.target !== undefined && e.target.selectedOptions !== undefined) {
        let desc = e.target.selectedOptions[0].text;
        inputList[0][key][metaKey] = desc;
        inputList[0][key][metaKey + "_id"] = val;
      } else {
        inputList[0][key][metaKey] = val;
      }
    }  else {
      inputList[0][key] = val;  
    }
    
    setInputList(list);
  };

  console.log(NewActivityDetails)
  useEffect(() => {
    // show check out after complete activity
    
    if (
      NewActivityDetails?.data &&
      parseInt(NewActivityDetails?.status) === 200
    ) {
      setOpenCheckIn(true);
      setCheckInText("Check out");
      setShowSelfie(true);
      setMessage(NewActivityDetails?.message);
    } else if (
      NewActivityDetails?.data !== undefined &&
      NewActivityDetails?.status !== 200
    ) {
      setCountToOpenModal(countToOpenModal + 1);
      setIsFailedModalOpen(true);
      setMessage(NewActivityDetails?.message);
    }
  }, [NewActivityDetails]);


  useEffect(() => {
  
    console.log(isCheckoutDetails)
    if (
      getUserJourney?.data  &&
      Object.keys(getUserJourney?.data).length > 0
    ) {
      if (
        Object.keys(isCheckoutDetails?.data).length === 0 && activityByIdDetails?.data &&
        parseInt(activityByIdDetails?.data?.status) === 1
      ) {
        setOpenCheckIn(true);
        setCheckInText("Check In");
      }
    } else if (getUserJourney?.data !== undefined) {
      toast.warning("You have not started your journey yet for today");
      setTimeout(() => {
        // window.location.href = `dealer-activity-list/${match?.params?.module_id}`;
      }, 1000);
    }
  }, [getUserJourney]);

  return (
    <>
      <SuccessModal
        isOpen={isSuccessModalOpen}
        msg={message}
        url={`dealer-activity-list/${match?.params?.module_id}`}
      />

      <FailedModal
        isOpen={isFailedModalOpen}
        msg={message}
        countToOpenModal={countToOpenModal}
      />
      <Loader isLoading={isLoading} />

      <div id="wrapper">
        <DashboardMenu />
        <div id="content-wrapper" className="d-flex flex-column">
          <div id="content">
            <Header title={"Activity"} history={history} />
            {/*BODY*/}

            <div className="container-fluid common-bg">
              { (
                <>
                  {openCheckIn ? (
                    <div className="popup-box">
                      <div className="box">
                        <DistanceCalculator
                          isMapShow={true}
                          calculateDistance={markAttendances}
                          moduleType={"UCD"}
                          checkInText={checkInText}
                          checkoutId={0}
                          accountId={match?.params?.account_id}
                          activityId={
                            activityByIdDetails?.data?.id
                              ? activityByIdDetails?.data?.id
                              : ""
                          }
                          documentUploadUrlPublic={documentUploadUrlPublic}
                          documentUrlDataPublic={documentUrlDataPublic}
                          showSelfie={showSelfie}
                          hideCheckButton={hideCheckIn}
                          // distance={distance}
                          lat={accountDetails?.data?.latitude}
                          long={accountDetails?.data?.longitude}
                        />
                      </div>
                    </div>
                  ) : (
                    <>
                      <form onSubmit={(e) => handleSubmit(e)}>
                        <div className="row">
                          <div className="col-md-12">
                            <div className="d-sm-flex align-items-center justify-content-between com-sub-heading">
                              <h1 className="h3 mb-0 text-black-100">
                                {/*<b>{getActivityDetails?.data?.name !== undefined ? getActivityDetails?.data?.name : "Close Activity"}</b>*/}
                                {/* <span style={{ color: "green" }}>
                                  {" "}
                                  {distance}
                                </span> */}
                              </h1>
                            </div>
                            {/*<div className="mb-0 bg-white">*/}
                            <div className="card-body bg-white">
                              <div className="user">
                                <div className="form-group row"> 
                                <div className="col-sm-6 mtk-075 d-mtk-03 float-field">
                                <input type="text"
                                       className="form-control form-control-user"
                                       placeholder=" "
                                       value={"UCD"}
                                       disabled={true}
                                />
                                <label className="large-label float-lb">
                                    Activity Type <i className="bi bi-asterisk astrick-icon"></i>
                                </label>
                            </div>
                                   <textarea
                                      className="form-control form-control-user"
                                      placeholder="MOM"
                                      onChange={(e) => handleInput("meta_data", e.target.value, "MOM", e)}
                                      required
                                      id="validationCustom01"
                                      rows="4"
                                      cols="50"
                                  ></textarea>
                                </div>
                              </div>
                            </div>
                            {/*</div>*/}
                            <div className="col-md-12 mt-4 d-flex">
                              <button className="btn btn-primary btn-user btn-block submit-btn">
                                Submit
                              </button>
                            </div>
                          </div>
                        </div>
                      </form>
                    </>
                  )}
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CompleteUCDActivity;
